import { format } from 'date-fns';
import { ru } from 'date-fns/locale';

export const formatArticleDate = (date: string) => {
  return format(new Date(date), 'dd MMM HH:mm', { locale: ru });
};
